import axios from "@/axios";

export const namespaced = true;

export const state = {
  lineItems: [],
  lineItemInvoiceStatus: false,
  lineItemErrors: [],
};

export const getters = {
  lineItems: (state) => {
    let lineItems = [];
   
    if (state.lineItems) {
      let lineItemNumbers = state.lineItems
        .filter((lineItem) => parseInt(lineItem.itemNumber))
        .map((lineItem) => {
          return { ...lineItem, itemNumber: parseInt(lineItem.itemNumber) };
        });

      let lineItemStrings = state.lineItems.filter(
        (lineItem) => !parseInt(lineItem.itemNumber)
      );

      lineItemNumbers = lineItemNumbers.sort();
      if (lineItemStrings) {
        lineItemStrings = lineItemStrings.sort();
        lineItems = lineItemNumbers.concat(lineItemStrings);
      } else {
        lineItems = lineItemNumbers;
      }
      return lineItems;
    }
  },
  lineItemInvoiceStatus: (state) => state.lineItemInvoiceStatus,
  lineItemErrors: (state) => state.lineItemErrors,
};

export const mutations = {
  SET_LINE_ITEMS: (state, response) => {
    state.lineItems = response.data;
  },
  SET_LINE_ITEM_INVOICE_STATUS(state, status) {
    state.lineItemInvoiceStatus = status;
  },
  SET_ERRORS(state, data) {
    state.lineItemErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.lineItemErrors = [];
  }
};

export const actions = {
  async getLineItems({ commit, state }, orderId) {
    var id = orderId;
    commit(
      "SET_LINE_ITEMS",
      await axios.get(`/api/invoiceitems/order/${orderId}`)
    );
  },

  async getLineItemInvoiceStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_LINE_ITEM_INVOICE_STATUS", false);
    } else {
      return await axios
        .get("/api/invoiceitems/status/" + id)
        .then(({ data }) => {
          if(data && data.length === 0) {
            commit("SET_LINE_ITEM_INVOICE_STATUS", true);
            commit("CLEAR_ERRORS");
          } else {
          commit("SET_LINE_ITEM_INVOICE_STATUS", false);
            commit("SET_ERRORS", data);
        }
        });
    }
  },
  async saveLineItem({ state }, lineItem) {
    return await axios.post("/api/invoiceitems", lineItem,{ config:{ showToast: false}});
  },

  async saveLineItems({ state }, data) {
    //let changedLineItems = state.lineItems.filter(item => ids.includes(item.lineItemId));
    return await axios.post("/api/invoiceitems/all", data,{ config:{ showToast: false}});
  },
};
